<script src="../util/tinymce.plugin.js"></script>
<template>
  <div class="main-content">
    <div class="updated-message-wrapper" v-if="successUpdateMessage">
      <div class="updated-message" style="display: block">
        <p>
          <img src="/assets/img/checkbox-outline.svg" alt="" />{{
            successUpdateMessage
          }}
        </p>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row mt-5">
        <div class="col-12">
          <div class="share-pictures-wrapper">
            <div class="save-document-form" v-if="!projectShared">
              <h2>Share up to 6 pictures</h2>
              <div class="add-your-pictures" v-show="files.length < 6">
                <div class="add-pictures-file">
                  <file-upload
                    class="pointer"
                    ref="upload"
                    :value="files"
                    :thread="thread"
                    @input="updatedValue"
                    :multiple="true"
                    :drop="true"
                    @input-filter="inputFilter"
                    @input-file="inputFile"
                    :extensions="extensions"
                    :accept="accept"
                    :add-index="true"
                    :post-action="postUrl"
                    :headers="headers"
                    :data="fileData"
                  >
                    <span style="display: block">Add Your Pictures</span>
                    <span class="icon-add">
                      <svg
                        width="24"
                        height="24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11H7a1 1 0 010-2h10a1 1 0 110 2zm-5 5a1 1 0 01-1-1V7a1 1 0 012 0v10a1 1 0 01-1 1z"
                          fill="#6E7077"
                        />
                      </svg>
                    </span>
                  </file-upload>
                </div>
              </div>
              <div class="upload-pictures-list" v-if="files.length">
                <div
                  class="upload-pictures-box"
                  v-for="file in files"
                  :key="file.id"
                >
                  <a
                    href="javascript:;"
                    class="close-pictures"
                    @click.prevent="$refs.upload.remove(file)"
                    ><img src="/assets/img/close-icon.svg" alt=""
                  /></a>
                  <div
                    class="upload-pictures-img"
                    v-if="file.thumb"
                    :style="{ backgroundImage: `url(${file.thumb})` }"
                  ></div>
                  <div
                    class="upload-pictures-img"
                    v-else-if="file.path"
                    :style="{ backgroundImage: `url('${file.path}')` }"
                  ></div>
                  <div v-if="file.error">{{ file.error }}</div>
                </div>
              </div>

              <div
                class="invalid-feedback"
                v-for="(file, index) in files"
                :key="index"
              >
                <span v-if="file.error"
                  >Picture {{ index + 1 }} ( {{ file.name }} )
                  {{ file.error }}</span
                >
              </div>
              <p>
                Save this as a document, you find it in your documents section
              </p>
              <div class="form-group">
                <div class="form-field">
                  <input
                    type="text"
                    v-model="formData.name"
                    placeholder="Document Name"
                    class="form-control"
                  />
                  <div
                    class="field-check"
                    v-show="formData.name.replace(/(\r\n|\n|\r)/gm, '')"
                  ></div>
                </div>
              </div>
              <div class="form-group">
                <div class="form-field">
                  <tinymce
                    id="editor"
                    :other_options="tinymceOptions"
                    :toolbar1="toolbar1"
                    v-model="formData.description"
                    placeholder="Description..."
                  ></tinymce>
                  <div class="field-check" v-show="formData.description"></div>
                </div>
              </div>
              <p>You can also add a Link to your PowerBI Project</p>
              <div class="form-group">
                <div class="form-field">
                  <input
                    type="text"
                    v-model="formData.link"
                    placeholder="Link"
                    :class="{ 'is-invalid': invalidUrl }"
                    class="form-control"
                  />
                  <div
                    class="field-check"
                    v-show="formData.link && !invalidUrl"
                  ></div>
                </div>
              </div>

              <div class="form-group mt-4">
                <div
                  class="custom-control form-field"
                  v-if="userData && userData.team_id"
                >
                  <span class="switch switch-sm">
                    <input
                      type="checkbox"
                      class="switch"
                      v-model="formData.team_shared"
                      id="switch-stm"
                    />
                    <label for="switch-stm">Save as a Team Document</label>
                  </span>
                  <div class="share-document-info">
                    <a
                      href="javascript:"
                      @mouseover="team_share_tooltip = true"
                      @mouseout="team_share_tooltip = false"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="20"
                        viewBox="0 0 23 20"
                      >
                        <g>
                          <g>
                            <path
                              d="M11.43 11.5c-.46 0-.831-.387-.831-.865v-5.77c0-.478.372-.865.83-.865.46 0 .831.387.831.865v5.77c0 .478-.372.865-.83.865zM.629 9.75C.629 4.365 5.464 0 11.429 0c5.966 0 10.802 4.365 10.802 9.75S17.395 19.5 11.43 19.5C5.464 19.5.629 15.135.629 9.75zm19.94 0c0-4.556-4.092-8.25-9.14-8.25-5.047 0-9.139 3.694-9.139 8.25S6.382 18 11.43 18c5.047 0 9.139-3.694 9.139-8.25zm-9.97 5c0-.414.372-.75.83-.75.46 0 .831.336.831.75s-.371.75-.83.75c-.46 0-.831-.336-.831-.75z"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </a>
                    <div
                      class="share-document-box"
                      onclick="return null;"
                      v-if="team_share_tooltip"
                    >
                      <p>
                        Saving as a Team Document will add this to your Team's
                        Documents section and will be visible to all your Team
                        Members.
                      </p>
                      <p class="mt-3">
                        Note - Team Documents cannot be shared as Community
                        Documents.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="custom-control form-field">
                  <span class="switch switch-sm">
                    <input
                      type="checkbox"
                      class="switch"
                      v-model="formData.shared"
                      id="switch-sm"
                    />
                    <label for="switch-sm">Share as a Community Document</label>
                  </span>
                  <div class="share-document-info">
                    <a
                      href="javascript:"
                      @mouseover="share_tooltip = true"
                      @mouseout="share_tooltip = false"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="20"
                        viewBox="0 0 23 20"
                      >
                        <g>
                          <g>
                            <path
                              d="M11.43 11.5c-.46 0-.831-.387-.831-.865v-5.77c0-.478.372-.865.83-.865.46 0 .831.387.831.865v5.77c0 .478-.372.865-.83.865zM.629 9.75C.629 4.365 5.464 0 11.429 0c5.966 0 10.802 4.365 10.802 9.75S17.395 19.5 11.43 19.5C5.464 19.5.629 15.135.629 9.75zm19.94 0c0-4.556-4.092-8.25-9.14-8.25-5.047 0-9.139 3.694-9.139 8.25S6.382 18 11.43 18c5.047 0 9.139-3.694 9.139-8.25zm-9.97 5c0-.414.372-.75.83-.75.46 0 .831.336.831.75s-.371.75-.83.75c-.46 0-.831-.336-.831-.75z"
                            ></path>
                          </g>
                        </g>
                      </svg>
                    </a>
                    <div
                      class="share-document-box"
                      onclick="return null;"
                      v-if="share_tooltip"
                    >
                      <p>
                        Sharing this as a Community Document allows anyone using
                        the Analyst Hub to see your document. This might be
                        useful if you are looking for feedback or if you simply
                        enjoy sharing your crafts with like-minded people.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <span
                class="invalid-feedback"
                v-if="formData.team_shared == true && formData.shared == true"
                >You can not share with both team and community, please choose
                one.</span
              >

              <div class="form-btn">
                <button
                  class="btn btn-primary"
                  v-if="
                    !formData.name ||
                    !files.length ||
                    $refs.upload.active ||
                    invalidUrl ||
                    busy ||
                    (formData.team_shared == true && formData.shared == true)
                  "
                  disabled="true"
                >
                  {{ saveBtnTextDisabled }}
                </button>
                <button
                  class="btn btn-primary"
                  v-else
                  @click.prevent="storeProject"
                >
                  {{ saveBtnText }}
                </button>
              </div>
            </div>

            <!-- Shared Document saved -->
            <div
              class="document-has-been-saved text-center"
              v-if="projectShared"
            >
              <h2>Shared!</h2>
              <h4>Your Document has been saved!</h4>
              <div class="thanks-check">
                <img src="/assets/img/check-icon-big.svg" alt="" />
              </div>

              <router-link
                v-if="$route.params.doc_id"
                :to="{
                  name: 'Document View',
                  params: { document_id: $route.params.doc_id },
                }"
                class="btn btn-primary"
                >OPEN THE DOCUMENT</router-link
              >

              <div class="feel-sharing-more">
                <h4>Feel like sharing some more?</h4>
                <a
                  href="/apps/project-share"
                  class="btn btn-alternative-primary"
                  >SHARE MORE PICTURES</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageCompressor from "@xkeshi/image-compressor";
import FileUpload from "vue-upload-component";
import DocumentHttpService from "../services/DocumentHttpService";
import JwtService from "../common/jwt.service";
import tinymce from "vue-tinymce-editor";

export default {
  name: "ProjectShare",
  components: {
    FileUpload,
    tinymce,
  },
  watch: {
    formData: {
      handler: function (val) {
        if (val.link) {
          let pattern = new RegExp(
            "^(https?:\\/\\/)?" + // protocol
              "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
              "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
              "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
              "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
              "(\\#[-a-z\\d_]*)?$",
            "i"
          );

          this.invalidUrl = !pattern.test(val.link);
        } else {
          this.invalidUrl = false;
        }
      },
      deep: true,
    },
  },
  data: function () {
    return {
      share_tooltip: false,
      team_share_tooltip: false,
      userData: false,
      fileData: {
        entity_name: "Portfolio",
        entity_group: "Portfolio",
        temp_id: null,
      },
      formData: {
        entity_name: "Portfolio",
        entity_group: "Portfolio",
        name: "",
        description: "",
        link: "",
        shared: false,
        team_shared: false,
        temp_id: null,
      },
      invalidUrl: false,

      putUrl: null,
      postUrl: "/api/document",
      files: [],
      accept: "image/png,image/gif,image/jpeg,image/webp",
      extensions: "gif,jpg,jpeg,png,webp",
      minSize: 1024,
      size: 1024 * 1024 * 5,
      multiple: true,
      directory: false,
      drop: true,
      dropDirectory: true,
      addIndex: false,
      thread: 6,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Authorization: `Bearer ${JwtService.getToken()}`,
      },
      busy: false,
      docService: new DocumentHttpService(),

      saveBtnText: "SAVE",
      saveBtnTextDisabled: "SAVE",

      projectShared: false,

      successUpdateMessage: "",
      latestThree: false,

      tinymceOptions: {
        // plugins: 'placeholder',
        menubar: false,
        branding: false,
        statusbar: false,
        content_style:
          "body { font-family: 'Poppins', sans-serif; padding-left: 17px; color: #16181F;\n" +
          "    font-size: 14px;\n" +
          "    font-weight: 400;\n" +
          "    line-height: normal; }",
        // placeholder_attrs:"Description..."
        link_title: false,
        contextmenu: "link image",
      },
      toolbar1:
        "formatselect | bold italic strikethrough | link | numlist bullist outdent indent",
    };
  },
  mounted() {
    const titleEl = document.querySelector("head title");
    titleEl.textContent = "Power BI Portfolio - Analyst Hub by Enterprise DNA";

    this.userData = JSON.parse(localStorage.getItem("user"));

    this.loadProject();
  },
  methods: {
    setTempId() {
      const TEMP_ID = Math.random().toString(16).slice(2, 10);
      this.formData.temp_id = TEMP_ID;
      this.fileData.temp_id = TEMP_ID;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
        // Automatic compression
        if (
          newFile.file &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: Infinity,
            maxWidth: 512,
            maxHeight: 512,
          });
          imageCompressor
            .compress(newFile.file)
            .then((file) => {
              this.$refs.upload.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type,
              });
            })
            .catch((err) => {
              this.$refs.upload.update(newFile, {
                error: err.message || "compress",
              });
            });
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
    // add, update, remove File Event
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        // update
        if (newFile.active && !oldFile.active) {
          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.upload.update(newFile, {
              error: "size is less than 1Kb",
            });
          }

          if (newFile.size >= this.size) {
            this.$refs.upload.update(newFile, {
              error: "size is more than 5MB",
            });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          this.busy = true;
          // progress
        }
        if (newFile.error && !oldFile.error) {
          // error
          // console.log(this.files);
          // console.log(newFile.name);
          // console.log(newFile.error);
        }
        if (newFile.success && !oldFile.success) {
          // success
          this.busy = false;
          this.projectShared = true;
        }
      }

      if (!newFile && oldFile) {
        // remove
        if (oldFile.success && oldFile.response.id) {
          // $.ajax({
          //   type: 'DELETE',
          //   url: '/upload/delete?id=' + oldFile.response.id,
          // })
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true;
        }
      }
    },
    // filter out non accepted file formats and limit the size to 6
    updatedValue(files) {
      files = files.filter((image) => {
        if (image.file) {
          return this.accept.split(",").includes(image.file.type);
        } else {
          return true;
        }
      });
      if (files.length > 6) {
        files.splice(6, files.length - 6);
      }
      this.files = files;
    },

    loadProject() {
      let docId = this.$route.params.doc_id;
      if (docId) {
        this.docService
          .get(docId)
          .then(({ data }) => {
            this.checkPaidPlanAccess(data.doc.latest_three);
            this.latestThree = data.doc.latest_three;

            const titleEl = document.querySelector("head title");
            titleEl.textContent =
              data.doc.name + " - Analyst Hub by Enterprise DNA";

            this.formData = {
              id: data.doc.id,
              name: data.doc.name,
              description: data.doc.description,
              link: data.entity.link || null,
              shared: data.doc.shared,
              entity_id: data.entity.id,
              entity_name: data.doc.entity_name,
              entity_group: data.doc.entity_group,
            };

            this.fileData = {
              entity_name: "Portfolio",
              entity_group: "Portfolio",
              id: data.doc.id,
            };

            // user check
            let user = JSON.parse(localStorage.getItem("user"));
            if (data.doc.user.id != user.id) {
              this.formData = {};
            }

            this.setTempId();

            if (typeof data.entity.pictures == "object") {
              data.entity.pictures = Object.values(data.entity.pictures);
            }
            this.files = data.entity.pictures;

            this.saveBtnText = "UPDATE";
          })
          .catch((response) => {
            console.log(response);
          });
      } else {
        this.setTempId();
      }
    },
    // when save clicked for first time
    storeProject() {
      // restriction check
      if (
        this.$route.params.doc_id &&
        this.latestThree &&
        !this.checkPaidPlanAccess(this.latestThree)
      ) {
        this.$router.push({ name: "Documents Limit" });
      } else if (!this.$route.params.doc_id && !this.checkPaidPlanAccess()) {
        this.$router.push({ name: "Documents Limit" });
      } else {
        this.busy = true;
        let postData = this.formData;
        postData.files = this.files;

        if (this.saveBtnText == "UPDATE") {
          this.saveBtnTextDisabled = "UPDATING...";
        } else {
          this.saveBtnTextDisabled = "SAVING...";
        }

        this.docService
          .store(postData)
          .then(({ data }) => {
            this.formData.id = data.doc.id;
            this.formData.entity_id = data.entity.id;
            this.formData.name = data.doc.name;
            this.formData.description = data.doc.description;
            this.formData.link = data.entity.link || null;
            this.formData.shared = data.doc.shared;
            if (this.formData.name) {
              this.$refs.upload.active = true;
            }

            if (!this.$route.params.doc_id) {
              this.$router.push({
                name: "Project Share",
                params: { doc_id: data.doc.document_id },
              });
            }

            setTimeout(() => {
              this.busy = false;
              if (this.saveBtnText == "UPDATE") {
                this.successUpdateMessage = "Document saved!";
                setTimeout(() => {
                  this.successUpdateMessage = "";
                }, 2000);
              }
            }, 800);
          })
          .catch((response) => {
            console.log(response);
          });
      }
    },

    checkPaidPlanAccess(latestThree) {
      // restriction check
      this.userData = JSON.parse(localStorage.getItem("user"));
      if (typeof latestThree == "undefined") {
        if (this.userData.free_plan && this.userData.documents_count >= 3) {
          return false;
        }
      } else {
        if (this.userData.free_plan && !latestThree) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style scoped>
.save-document-form .field-check {
  top: 24px;
}

.save-document-form div.custom-control {
  z-index: unset;
}
.save-document-form
  div.custom-control
  .share-document-info
  div.share-document-box {
  z-index: 1;
}
</style>
